import {
  Suggestion,
  SuggestionList,
  SuggestionLists,
  SuggestionType,
  SuggestionValueType,
} from '~domain/model/core/suggestion';
import { ErrorMessage, Rule } from '~domain/model/core/validation/rule';
import { BaseValidator } from '~domain/validators/core/base-validator';
import { InclusionValidator } from '~domain/validators/core/basic-types/inclusion-validator';

// Validate value exists in the suggestion
export class SuggestionValidator extends BaseValidator<SuggestionValueType> {
  protected rules: Rule<SuggestionValueType>[] = [this.createNullRule(), this.validateContent];
  private inclusionValidator: InclusionValidator<SuggestionValueType>;

  constructor(suggestionType: SuggestionType, errorMessage?: string) {
    super();
    // Create inclusion validator from suggestion values
    this.inclusionValidator = new InclusionValidator(
      SuggestionLists.find((list: SuggestionList) => list.id === suggestionType).suggestions.map(
        (choice: Suggestion) => choice.value,
        errorMessage || 'validation.error.choiceNotIncluded',
      ),
    );
  }

  private validateContent(value: SuggestionValueType): ErrorMessage {
    return this.inclusionValidator.validate(value);
  }
}
